<template>
  <el-image-viewer
    :url-list="[imageUrl]"
    :initial-index="0"
    @close="handleClose"
  />
</template>

<script setup>
import { defineProps, defineEmits, computed} from 'vue';

const props = defineProps({
  url: {
    type: String,
    default: '',
  }
});

const emit = defineEmits(['close']);

const imageUrl = computed(() => {
  const [bucketName, filePath] = props.url.split(':') || [];
  return bucketName && filePath ? `https://s3.ap-northeast-2.amazonaws.com/${bucketName}/${filePath}` : '';
});

const handleClose = () => {
  emit('close');
};
</script>
